// 热门标签
export const HOTTAGSLIST = 'hont-tags-list'
// 热门专题
export const HOTCOLUMNLIST = 'Hot-column-list'
